module.exports = __webpack_public_path__ + "static/assets/603dbe0f4668e31811287814ace0eed7.svg";